// src/components/SoutiensFinanciers.jsx
import React from "react";
import './chapter.css';

export default function SoutiensFinanciers() {
  return (
    <section className="chapter">
      <header className="chapter__header">
        <h2 className="chapter__title">Le coin des investisseurs</h2>
        <p className="chapter__subtitle">
          Le projet <br />
          <a href="https://www.land-of-innovation.ch" target="_blank" rel="noopener noreferrer">
            Land-Of-Innovation
          </a>
          <br />
          vise à mettre en relation les porteurs de projets innovants avec vous, investisseurs engagés dans l’innovation. Vous pourrez ainsi sublimer une région qui a tout pour vous accueillir et vous permettre de vous y sentir bien.
        </p>
        <p className="chapter__subtitle">
          Ce projet valorise le savoir-faire local, attire des sociétés innovantes et vous invite, lors d’événements organisés de main de maître par nos partenaires, à découvrir ces initiatives et à y prendre part.
        </p>
      </header>

      <div className="chapter__content">
        <div className="chapter__block">
          <h3 className="chapter__block-title">Pourquoi soutenir l'innovation en Suisse romande</h3>
          <p className="chapter__block-text">
            On entend régulièrement dans la presse, surtout chez nos voisins, que vous êtes les bêtes noires, qu’il faudrait vous ponctionner.  
            <br />
            Nous ne partageons pas cette vision. Nous savons que c’est grâce à vous que les innovations de demain voient le jour.  
            <br />
            C’est pourquoi nous vous invitons à nous rejoindre et à profiter de tous les atouts de cette magnifique région. Un aéroport situé au cœur vous permet de rejoindre les principales capitales européennes en quelques heures.  
            <br />
            Lors de nos communications, nous mettrons en avant que c’est grâce à vous que ces projets ont vu le jour — une manière de contrer les discours malveillants à votre égard.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Comment rejoindre Land-Of-Innovation en tant qu'investisseur</h3>
          <p className="chapter__block-text">
            C’est la partie la plus exigeante : il faut être recommandé par un membre déjà actif. Pourquoi ?  
            Parce que nous recherchons des investisseurs motivés, capables d’investir et de s’investir dans les projets pour en faire des réussites — et pourquoi pas, de temps en temps, une licorne.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">En contrepartie</h3>
          <p className="chapter__block-text">
            Nous nous engageons à vous présenter des projets susceptibles de susciter votre intérêt : bien préparés, avec des présentations abouties.  
            Des porteurs de projets motivés, conscients des défis à relever et prêts à déplacer des montagnes pour atteindre le succès.
          </p>
        </div>
      </div>
    </section>
  );
}
